<template>
  <div class="container mt-5 mb-5">
    <div class="jumbotron text-center">
      <h1 class="text-warning">Error 401 - Unauthorized</h1>
      <h3>You do not have permission to access this page</h3>
      <h5>You may need to be logged in order to acces the page you are looking for</h5>      
    </div>
  </div>
</template>

<script>
export default {
  name: 'error401',
  data() {
    return {}
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Error401.vue